<template>
  <div class="z-10 fixed inset-0 bg-black bg-opacity-25 flex flex-col justify-end" v-if="isOpen">
    <div class="z-10 p-3">
      <div class="bg-white rounded-lg overflow-hidden mb-3">
        <div class="flex flex-col" v-if="state == 'Idle'">
          <button
            @click="editRecipe"
            class="bg-white active:bg-gray-200 text-lg py-4 border-b border-gray-300 last:border-0 flex justify-center items-center"
          >
            <svg
              class="stroke-current h-6 w-6 mr-2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.25"
              viewBox="0 0 24 24"
            >
              <path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            <span>Edit Recipe</span>
          </button>
          <button
            @click="state = 'ConfirmDelete'"
            class="bg-white active:bg-gray-200 text-lg py-4 border-b border-gray-300 last:border-0 flex justify-center items-center"
          >
            <svg
              class="stroke-current h-6 w-6 mr-2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.25"
              viewBox="0 0 24 24"
            >
              <path
                d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"
              />
            </svg>
            <span>Delete Recipe</span>
          </button>
        </div>
        <div class="flex flex-col" v-if="state == 'ConfirmDelete'">
          <p class="text-sm text-center text-gray-700 p-4 border-b border-gray-300 last:border-0">
            <span>Are you sure you want to delete this recipe?</span>
            <br />
            <span>Note, at this point, you are unable to recover deleted recipes.</span>
          </p>
          <button
            @click="deleteRecipe"
            class="bg-white active:bg-gray-200 text-lg py-4 border-b border-gray-300 last:border-0 flex justify-center items-center"
          >
            <svg
              class="stroke-current h-6 w-6 mr-2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.25"
              viewBox="0 0 24 24"
            >
              <path
                d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"
              />
            </svg>
            <span>Confirm Delete</span>
          </button>
        </div>
      </div>
      <button
        @click="close"
        class="w-full bg-white active:bg-red-700 text-red-700 active:text-white rounded-lg text-lg font-bold py-4"
      >Cancel</button>
    </div>
    <div @click="close" class="fixed inset-0"></div>
  </div>
</template>

<script>
export default {
  name: "MoreActions",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: "Idle"
    };
  },
  methods: {
    deleteRecipe: function() {
      this.$emit("deleteRecipe");
    },
    editRecipe: function() {
      this.$emit("editRecipe");
    },
    close: function() {
      this.state = "Idle";
      this.$emit("close");
    }
  }
};
</script>